import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import RequiredIndicator from './required-indicator';
import { TooltipDisplay } from './tooltip-display';
import styleable from 'react-styleable';
import defaultStyle from './common.style.js';

export class RequiredLegend extends Component {
  render() {
    const { hasErrors, tooltip, isRequired, content, css } = this.props;

    return(
      <legend className={css.requiredLegend} aria-label={content}>
        {hasErrors ? <span id="error-icon" className={css.errorIndicator} aria-hidden='true'/> : null}
        {content}
        { tooltip ? <TooltipDisplay text={tooltip}/> : null}
        <RequiredIndicator css={css} isRequired={isRequired}/>
      </legend>
    );
  }
}

RequiredLegend.propTypes = {
  hasErrors: PropTypes.bool,
  content: PropTypes.string.isRequired,
  isRequired: PropTypes.bool.isRequired,
  tooltip: PropTypes.string,
};

export default styleable(defaultStyle) (RequiredLegend);
